import React from "react";
import { Button, Modal, Text } from "@mantine/core";
import { ArrowMerge, FilePlus } from "tabler-icons-react";

interface FlexOptionsChoiceModalProps {
  opened: boolean;
  onClose: () => void;
  onMerge: () => void;
  onCreateNew: () => void;
  existingDocs: any[];
  assetType: string;
}

export function FlexOptionsChoiceModal({ opened, onClose, onMerge, onCreateNew, existingDocs, assetType }: FlexOptionsChoiceModalProps) {
  return (
    <Modal opened={opened} onClose={onClose} title="Flex Options Set Exists" size="lg">
      <Text size="sm" mb="sm">One or more flex options sets for this asset type "{assetType}" already exists.</Text>
      <Text size="sm" mb="lg">What would you like to do?</Text>
      <div style={{ display: "flex", gap: "8px", justifyContent: "space-between" }}>
        <Button color="cap-navy" variant="outline" style={{ width: "50%" }} onClick={() => { onMerge(); onClose(); }} leftIcon={<ArrowMerge />}>
          Merge with existing set
        </Button>
        <Button color="cap-navy" variant="outline" style={{ width: "50%" }} onClick={() => { onCreateNew(); onClose(); }} leftIcon={<FilePlus />}>
          Create new set
        </Button>
      </div>
    </Modal>
  );
}